import React from 'react'
import { Button as ChButton, forwardRef } from '@chakra-ui/react'

import Link from './Link'

const Button = forwardRef(({ href, to, linkHover, ...props }, ref) => {
  if (href || to)
    return (
      <ChButton
        as={(p) => (
          <Link ref={ref} {...p} to={to} href={href} _hover={{ linkHover }} />
        )}
        {...props}
      />
    )
  return <ChButton ref={ref} {...props} />
})

Button.defaultProps = {
  color: 'white',
  bg: 'transparent',
  border: '2px solid',
  borderRadius: 'full',
  height: 'auto',
  width: 'auto',
  py: '0.5rem',
  px: '2.25rem',
  fontWeight: '500',
}

Button.Secondary = (props) => <Button colorScheme="green" {...props} />

Button.Danger = (props) => <Button colorScheme="red" {...props} />

Button.Outline = (props) => (
  <Button
    _hover={{
      bg: 'white',
      color: 'black',
      borderColor: 'white',
    }}
    _active={{
      bg: 'white',
      color: 'black',
      borderColor: 'white',
    }}
    filter="drop-shadow(4px 5px 5px black)"
    {...props}
  />
)

Button.Transparent = (props) => (
  <Button
    bg="transparent"
    color="custom.text"
    border="none"
    _hover={{ bg: 'transparent' }}
    _active={{ bg: 'transparent' }}
    {...props}
  />
)

export default Button
